import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileSyncOutlinedSvg from "@ant-design/icons-svg/es/asn/FileSyncOutlined";
import AntdIcon from "../components/AntdIcon";
var FileSyncOutlined = function FileSyncOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileSyncOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileSyncOutlined.displayName = 'FileSyncOutlined';
}
export default /*#__PURE__*/React.forwardRef(FileSyncOutlined);